import { NgClass } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, Inject, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { AvailableLangs, TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { Subject, takeUntil } from 'rxjs';
import { ZardMenuModule } from 'app/shared/components/ui/menu/menu.module';
import { ZardButtonComponent } from 'app/shared/components/ui/button/button.component';
import { ZardAvatarComponent } from 'app/shared/components/ui/avatar/avatar.component';
import { ZardDividerComponent } from 'app/shared/components/ui/divider/divider.component';

@Component({
  selector: 'app-user-modal',
  standalone: true,
  imports: [MatIconModule, TranslocoModule, ZardMenuModule, ZardButtonComponent, ZardAvatarComponent, ZardDividerComponent],
  templateUrl: './user-modal.component.html',
  styleUrl: './user-modal.component.scss'
})
export class UserModalComponent implements OnInit {
  user: User;
  username : string = '';
  availableLangs: AvailableLangs;
  activeLang: string;
  flagCodes: any;
  langName : string = '';
  langNames: { [key: string]: string } = {
    en: 'English',
    sq: 'Albanian',
    es: 'Spanish',
    pt: 'Portuguese',
    tr: 'Turkish',
  };
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private _userService: UserService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _router : Router,
    private _translocoService: TranslocoService
  ){
    this._userService.user$
      .pipe(takeUntil(this._unsubscribeAll))
        .subscribe((user: User) => {
          this.user = user;
          this.username = user.username.charAt(0).toUpperCase() + user.username.slice(1);
          this._changeDetectorRef.markForCheck();
      });
    
    this.availableLangs = this._translocoService.getAvailableLangs();

    const savedLang =
      localStorage.getItem('selectedLang') ||
      this._translocoService.getDefaultLang();
      this.setActiveLang(savedLang);

      this.langName = this.langNames[savedLang]

  

    this._translocoService.langChanges$.subscribe((activeLang) => {
        this.activeLang = activeLang;
    });

    this.flagCodes = {
      en: 'us',
      sq: 'sq',
      es: 'es',
      pt: 'pt',
      tr: 'tr',
    };

  }
  ngOnInit(): void {
    // Component initialization
  }

  setActiveLang(lang: string, langLabel ?: string): void {
    this._translocoService.setActiveLang(lang);
    this.langName = langLabel;
    localStorage.setItem('selectedLang', lang);
  }




  trackByFn(index: number, item: any): any {
    return item.id || index;
  }

  goToSettings(): void {
    this._router.navigate(['/settings/profile']);
  }

  goResetPassword(): void {
    this._router.navigate(['/settings/change-password']);
  }

  signOut(): void {
    this._router.navigate(['/sign-out']);
  }

  getInitials(name: string): string {
    if (!name) return 'U';
    const words = name.trim().split(' ');
    if (words.length === 1) {
      return words[0].charAt(0).toUpperCase();
    }
    return (words[0].charAt(0) + words[words.length - 1].charAt(0)).toUpperCase();
  }

}
